'use client';
import { Checkbox } from './Checkbox';

/** The select checkbox one card of a `CardGrid` leads with when its register supports bulk actions.
 *  It is the card registers' one shared selection control: memories, skills, agent types and MCP
 *  servers all tick the same box.
 *
 *  The button owns the toggle and the accessible name; the `Checkbox` inside is presentational paint.
 *  Activation stops at the button — ticking it never opens the entry underneath — for the pointer and
 *  for the two keys the checkbox consumes. A register's roving arrow/Home/End navigation lives on the
 *  card precisely because a keystroke aimed at any cell reaches it there, so anything beyond Space and
 *  Enter keeps travelling. `checked` drives both the paint and `aria-pressed`, and the selected card
 *  reads as selected through the `CardGridItem` `selected` styling beside it. `disabled` locks the
 *  box while its register's bulk action runs, so the selection cannot change under a running write. */
export function CardSelectCheckbox({ checked, label, onToggle, disabled = false }: {
  checked: boolean;
  label: string;
  onToggle: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={(event) => { event.stopPropagation(); onToggle(); }}
      onKeyDown={(event) => {
        if (event.key === ' ' || event.key === 'Enter') event.stopPropagation();
      }}
      aria-label={label}
      aria-pressed={checked}
      title={label}
      disabled={disabled}
      className="flex items-center justify-center disabled:opacity-40"
    >
      <Checkbox checked={checked} />
    </button>
  );
}
